import { render, staticRenderFns } from "./AppendixDialog.vue?vue&type=template&id=c495d7b8&scoped=true"
import script from "./AppendixDialog.vue?vue&type=script&lang=ts"
export * from "./AppendixDialog.vue?vue&type=script&lang=ts"
import style0 from "./AppendixDialog.vue?vue&type=style&index=0&id=c495d7b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c495d7b8",
  null
  
)

export default component.exports